<template>
  <div class="alert alert-danger" role="alert" v-if="showErrors">
    <ul class="pl-4 mb-0"
        role="alert"
        v-for="error in errorsToRender"
        :key="error.message">
      <li>
        {{error.message}}
      </li>
    </ul>
  </div>
</template>

<script>
  import contains from 'ramda/src/contains'
  import filter from 'ramda/src/filter'
  import isEmpty from 'ramda/src/isEmpty'

  export default {
    props: {
      errors: {
        type: Array,
        default: () => []
      },
      omitFields: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      errorsToRender() {
        const shouldRender = (error) => !contains(error.field, this.omitFields)
        return filter(shouldRender, this.errors)
      },
      showErrors() {
        return !isEmpty(this.errorsToRender)
      }
    }
  }
</script>
